export enum ArtificialIntelligenceStatus {
  Approve = 'Approve',
  Decline = 'Decline',
  Unknown = 'Unknown',
}
